<h2 *ngIf="complianceArea" style="font-family: Roboto, 'Helvetica Neue', sans-serif;    margin-left: 40px;">
  Map {{complianceArea.name}} Control Items to WS Items
</h2>
<p-table [value]="controlItems"
             rowGroupMode="subheader"
             dataKey="category"
             expandableRowGroups="true"
             [paginator]="false"
>
  <ng-template pTemplate="header">
    <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
      <th style="text-align: center;width: 20%">
        Control Item
      </th>
      <th style="text-align: center;width: 10%">WS Item Name</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded">
    <tr class="ui-widget-header"
        *ngIf="rowGroupMetadata && rowGroupMetadata[item.category].index === rowIndex">
      <td [attr.colspan]="2">
        <a href="#" [pRowToggler]="item">
          <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
          <span>{{item['category']}}</span>
        </a>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="expandedrow" let-item>
    <tr>
      <td>{{item.complianceAreaControlId}}
        <img [src]="'../../../assets/icon/' + (item.isCloned ? 'broadcast.svg' : 'crossmap.png')" height="20px" *ngIf="item.broadcast"/>
      </td>
      <td style="text-align: center" class="wsids">
        <span *ngFor="let ws of item.workstreamItems"
            pTooltip="{{ws.workstreamName}}">
          <span>{{ws.wsid}}</span>
          <span class="pi pi-trash" (click)="deleteWsid(item, ws.workstreamItemId)"></span>
        </span>
        <span class="pi pi-plus" (click)="selectWsid(item)"></span>
      </td>
    </tr>
  </ng-template>

</p-table>
